import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { withStyles, WithStyles } from '@zn-material-ui'
import { RouteComponentProps } from 'react-router'
import { IUserStore } from '@stores/UserStore'
import { getQueryParams } from '@utils/url'
import { IAppStore } from '@stores/AppStore'
import Store from 'store'
import Loading from '@components/Loading'
import { getUrlParam } from '@utils'
import LoginForm from '../components/LoginForm'
import LeftLogo from '../components/LeftLogo'
import loginStyles from './styles/LoginStyle'
import knowledgeC_bg from '@images/login/knowledgeC_bg.png'
import defaultBg from './imgs/defaultBg.png'
import { transform } from '@utils/intl_lang'
import { isIE } from '@utils'
import ConfirmDialog from '@components/Dialog'

export interface IProps {
  history: RouteComponentProps['history']
  match: RouteComponentProps<{ from: string }>['match']
  UserStore: IUserStore
  AppStore: IAppStore
  coverImg?: string
  platformName?: string
  from?: string,
  isCanCelLogin: boolean
  route?: string
}

export interface IKnowledgeTheme {
  platformName: string
  coverImg: string
}
interface ILoginProps extends IProps, WithStyles<typeof loginStyles> {}
@inject('UserStore', 'AppStore')
@observer
class Login extends React.Component<ILoginProps, any> {
  state ={
    DialogVisible: false, // IE兼容提示弹窗可见性
  }
  /**
   * 智门户2022-0225版本增加IE浏览器兼容提示
   */
  private checkIsUsingIE = () => {
    if (isIE()) {
      this.setState({ DialogVisible: true })
    }
  }

  public componentDidMount() {
    Store.remove('liveUserInfo')
    Store.remove('otherUserInfo')
    this.checkIsUsingIE()
  }

  public render() {
    const { DialogVisible } = this.state
    const { classes, ...props } = this.props
    const individuationKey = getUrlParam('individuationKey')
    const route = getUrlParam('route')
    let knowledgeTheme = {} as IKnowledgeTheme
    if (route.includes('knowledge-cloud')) {
      knowledgeTheme = {
        platformName: transform('zhiniao_cloud'), // e祺学知识云
        coverImg: knowledgeC_bg,
      }
    }
    const fromProps={
      ...props,
      route,
    }
    return (
      <div className={classes.login}>
        {individuationKey && !props.AppStore.individuationKey ? (
          <Loading />
        ) : (
          <>
            <LeftLogo
              AppStore={props.AppStore}
              // coverImg={knowledgeTheme.coverImg || ''}
              coverImg={defaultBg}
            />
            <LoginForm {...fromProps} platformName={knowledgeTheme.platformName} />
            <ConfirmDialog
              onOk={() => this.setState({ DialogVisible: false })}
              visible={DialogVisible}
              content={(
                <div className ={classes.dialogSpan}>由于浏览器兼容原因，建议使用谷歌浏览器。</div>
              )}
              confirmAndCancel={false}
              okText='我知道了'
            />
          </>
        )}
      </div>
    )
  }
}

export default withStyles(loginStyles)(Login)
